import React from 'react'
import styled, { css } from 'styled-components'
import { Link } from 'gatsby'
import theme from '../../styles/theme'
import SignOut from '../sign-out'
import IconUser from '../svg/icon-user'
import { getDatePassed } from '../../utils/validateUser'

export default ({ pathname, authUser }) => {
  const isActive = itemPath => {
    // console.log(
    //   'itemPath === pathname',
    //   itemPath,
    //   pathname,
    //   itemPath === pathname
    // )
    return itemPath === pathname
  }

  const isDisabled = getDatePassed(authUser).hasWeekPassed

  let accountLink
  if (!authUser.roles.studentClass) {
    accountLink = (
      <AccountLink>
        <Link to="/account" title="My Account">
          <UserIconWrap>
            <IconUser />
          </UserIconWrap>
          Account
        </Link>
      </AccountLink>
    )
  }

  const { teacher: isTeacher, admin: isAdmin } = authUser.roles
  const showTeacher = isTeacher || isAdmin

  return (
    <Wrap>
      <Header>
        {accountLink}
        <SignOut />
      </Header>
      <ItemLrg
        isActive={isActive('/graphic-design')}
        highlight={theme.colors.highlight1}
        disabled={isDisabled}
      >
        <Link to="/graphic-design">
          Graphic
          <br />
          Design
        </Link>
      </ItemLrg>
      <ItemLrg
        isActive={isActive('/career-guide')}
        highlight={theme.colors.highlight2}
        disabled={isDisabled}
      >
        <Link to="/career-guide">
          Career
          <br />
          Guide
        </Link>
      </ItemLrg>
      {showTeacher && (
        <ItemLrg
          isActive={isActive('/teacher-guide')}
          highlight={theme.colors.highlight3}
          disabled={isDisabled}
        >
          <Link to="/teacher-guide">
            Teacher
            <br />
            Guide
          </Link>
        </ItemLrg>
      )}
      <Item isActive={true}>
        <Link to="/account-support">Support</Link>
      </Item>
      <Item isActive={true}>
        <Link to="/account-faq">FAQ</Link>
      </Item>
      <Item isActive={true}>
        <Link to="/account-terms">Terms of Use</Link>
      </Item>
    </Wrap>
  )
}

const Wrap = styled.div`
  position: fixed;
  right: 0px;
  top: 0px;
  height: 100%;
  width: calc(20% + 36px);
  border-left: 1px solid ${props => props.theme.colors.greyDark2};
  z-index: 1000;
  /* width: calc(20% - 30px); */
  a {
    text-decoration: none;
  }
  @media screen and (max-width: ${props => props.theme.responsive.md}) {
    width: calc(20% + 21px);
  }
  @media screen and (max-width: ${props => props.theme.responsive.sm}) {
    /* right: 20px; */
    display: none;
  }
`

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  padding-right: 60px;
  padding-left: 16px;
  height: 100px;
  align-items: center;
  border-bottom: 1px solid ${props => props.theme.colors.greyDark2};
  @media screen and (max-width: ${props => props.theme.responsive.md}) {
    padding-right: 35px;
    height: 76px;
  }
  @media screen and (max-width: ${props => props.theme.responsive.sm}) {
    padding-right: 60px;
  }
`

const ItemLrg = styled.div`
  :first-child {
    border-top: 1px solid ${props => props.theme.colors.greyDark2};
  }
  border-bottom: 1px solid ${props => props.theme.colors.greyDark2};
  ${props => props.theme.fontSizing(props.theme.font.navLrgSizes)};
  font-weight: bold;
  a {
    display: block;
    padding: 20px 30px 40px 16px;
    transition: background 0.4s ease-out;
    color: ${props =>
      props.isActive ? props.highlight : props.theme.colors.white};
    &:hover {
      opacity: 0.8;
    }

    ${({ disabled, theme }) =>
      disabled &&
      css`
        color: ${theme.colors.greyDark2};
        pointer-events: none;
      `};
  }
  @media screen and (max-width: ${props => props.theme.responsive.md}) {
    a {
      padding: 15px 30px 30px 13px;
    }
  }
  @media screen and (max-width: ${props => props.theme.responsive.sm}) {
    a {
      padding: 12px 11px 26px 11px;
    }
  }
`

const Item = styled.div`
  border-bottom: 1px solid ${props => props.theme.colors.greyDark2};
  ${({ disabled, theme }) =>
    disabled &&
    css`
      a {
        color: ${theme.colors.greyDark2} !important;
      }
      pointer-events: none;
    `};
  ${props => props.theme.fontSizing(props.theme.font.navMiniSizes)};
  a,
  span,
  em {
    display: block;
    padding: 15px 30px 15px 16px;
    background: transparent;
    color: ${props =>
      props.isActive ? props.theme.colors.white : props.theme.colors.greyDark5};
  }
  em {
    display: none;
    font-style: normal;
  }
  a {
    &:hover {
      opacity: 0.8;
    }
  }
  &:hover {
    span {
      display: none;
    }
    em {
      display: block;
    }
  }
  @media screen and (max-width: ${props => props.theme.responsive.sm}) {
    a {
      padding: 15px 30px 15px 13px;
    }
  }
  @media screen and (max-width: ${props => props.theme.responsive.sm}) {
    a {
      padding: 13px 22px 13px 11px;
    }
  }
`

const AccountLink = styled.span`
  a {
    display: flex;
    align-items: center;
    color: ${props => props.theme.colors.white};
  }
`
const UserIconWrap = styled.span`
  /* display: block;
  width: 48px;
  height: 48px;
  border: 2px solid ${props => props.theme.colors.highlight1};
  border-radius: 48px;
  margin-right: 10px;
  display: flex;
  justify-content: center;
  align-items: center; */
  ${props => props.theme.circleButton(props.theme.colors.highlight1)}
  margin-right: 10px;
  @media screen and (max-width: ${props => props.theme.responsive.md}) {
    svg {
      width: 16px;
    }
  }
`
